<!-- eslint-disable max-len -->
<template>
  <div class="character-select-root">
    <div v-if="label" style="margin-bottom: 2px;">
      <label style="margin-bottom: 0px;" :for="_uid">{{ $slots.default && $slots.default[0].text || '' }}</label>
      <div style="font-style: italic; font-size: 0.8em;" v-if="value && value !== ''"> ({{displayValue}} currently selected)</div>
    </div>
    <div class="csi-buttons-container">
      <b-btn v-focus="(value) ? false : autofocus" class="btn" style="padding: 10px; margin-left: 10px;" @click="show">
        <i class="fas fa-folder" style="margin-right: 2px;" /> {{ label || value === '' ? fallbackButtonLabel : displayValue}}
      </b-btn>
      <div v-if="to && value" style="margin-left: 2px; padding: 10px;">
        <a
          class="btn btn-sm"
          target="_blank"
          :href="`/blade/characters/${selectedCharacterId}/edit`"
          style="line-height: unset;">
          <i class="fas fa-pencil-alt" style="margin-right: 2px;" /> Details
        </a>
      </div>
      <b-btn v-if="value && !selectFolder" class="btn" style="padding: 10px; margin-left: 10px;" @click="()=>{ if (selectFolder) { selectDirectory(null) } else { selectCharacter(null) } }">
        <i class="fas fa-trash" style="margin-right: 2px;" /> {{remove ? 'Clear' : 'Remove'}}
      </b-btn>
      <b-btn
        v-if="remove"
        class="btn"
        style="padding: 10px; margin-left: 10px;"
        @click.prevent="remove"
      ><strong>X</strong></b-btn>
    </div>
    <div style="font-style: italic; font-size: 12px;" v-if="selectedCharacterObject && selectedCharacterObject.isOldCharacter">
      <span style="color: red; font-weight: bold;">WARNING: Character is not centralized.</span>
      Please select a character from the character explorer or <router-link :to="`/blade/characters/${selectedCharacterObject._id}/edit`">copy the selected character into the centralized character repository.</router-link>
    </div>
    <b-modal v-if="modalLoaded || true" :title="`${selectFolder ? 'Folder' : 'Character'} Selector`" size="xl" centered ref="modal" hide-footer>
      <div style="max-height: 80vh; overflow-y: auto; padding: 10px;">
        <character-tree-visualizer
          :root="root"
          :startPath="startPath"
          :filterCallback="filterCallback"
          :defaultFilters="defaultFilters"
          :select-folder="selectFolder"
          :hide-characters="hideCharacters"
          :selected-id="selectedCharacterId"
          @character-selected="selectCharacter"
          @directory-selected="selectDirectory"
        />
      </div>
    </b-modal>
    <!-- {{({selectedCharacterId, selectedCharacterObject, selectedPath, value})}} -->
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'character-select-input',
  components: {
    // Note: See the following link for an explanation
    // https://stackoverflow.com/a/58875919
    CharacterTreeVisualizer: () => import('../../blade/pages/components/CharacterTreeVisualizer')
  },

  computed: {
    displayValue() {
      if (this.selectFolder) {
        return this.selectedPath || this.value || 'Nothing selected';
      }
      if (this.selectedCharacterObject) {
        return this.selectedCharacterObject.name;
      }
      return 'Loading...';
    },
    fallbackButtonLabel() {
      if (this.selectFolder) {
        return 'Select Folder';
      }
      return 'Select Character';
    }
  },

  props: {
    autofocus: { type: Boolean },
    disabled: { type: Boolean },
    label: { type: Boolean, default: true },

    root: { type: String, default: '/' },
    startPath: { type: String, default: '/' },
    defaultFilters: { type: Object, default: () => ({}) },
    filterCallback: { type: Function, default: null },
    hideCharacters: Boolean,
    selectFolder: Boolean,
    selectOnlyId: Boolean,
    selectedId: String,

    to: { default: null },
    remove: { type: Function },

    value: { default: null },
    validator: { type: Object },
  },

  watch:
  {
    value() {
      if (this.selectFolder) {
        this.selectedPath = this.value;
      } else if (this.value && this.value._id) {
        this.selectedCharacterId = this.value._id;
      } else {
        this.selectedCharacterId = this.value;
      }
    },
    async selectedCharacterId(val) {
      if (val) {
        this.$set(this, 'selectedCharacterObject', (await this.getCharacter({ characterId: val })).character);
      } else {
        this.selectedCharacterObject = null;
      }
    }
  },

  data() {
    return {
      modalLoaded: false,
      selectedCharacterId: null,
      selectedCharacterObject: null,
      selectedPath: null
    };
  },

  mounted() {
    if (this.value) {
      if (this.selectFolder) {
        this.selectedPath = this.value;
      } else if (this.selectOnlyId) {
        this.selectedCharacterId = this.value;
      } else {
        this.selectedCharacterId = this.value ? this.value._id : null;
      }
    }
  },

  methods: {
    ...mapActions([
      'getCharacter'
    ]),
    selectDirectory(dir) {
      if (dir) {
        this.selectedCharacterId = null;
        this.selectedPath = dir.path;

        this.$emit('directory-selected', dir);
        this.$emit('input', dir.path);
      } else {
        this.selectedCharacterId = null;
        this.selectedPath = '';

        this.$emit('directory-selected', null);
        this.$emit('input', '');
      }
      this.$refs.modal.hide();
    },
    selectCharacter(character) {
      if (character) {
        this.selectedCharacterId = character._id;
        // console.log({ char: Object.assign({}, character) });

        this.$emit('character-selected', character);

        if (this.selectOnlyId) {
          this.$emit('input', character._id);
        } else {
          this.$emit('input', character);
        }
      } else {
        this.selectedCharacterId = null;
        this.$emit('character-selected', null);
        this.$emit('input', null);
      }

      this.$refs.modal.hide();
    },
    internalShow() {
      this.$refs.modal.show();
    },
    show() {
      if (!this.modalLoaded) {
        this.modalLoaded = true;
        this.$nextTick(() => {
          this.internalShow();
        });
        return;
      }
      this.internalShow();
    }
  }
};
</script>

<style lang="scss" scoped>
.character-select-root
{
  background-color: #eeeeee;
  border-radius: 5px;
  border: 1px solid rgba(0,0,0,0.2);
  padding: 15px;
  margin-bottom: 15px;
}

.csi-buttons-container
{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/inputs/CharacterSelectInput.vue